// @ts-nocheck
import { useState, useEffect } from 'react';
import { Typeahead, ClearButton } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

const Autocomplete = (props: any) => {
    const [selected, setSelected] = useState([]);
    
    useEffect(() => {
        window.addEventListener("SetAutocompleteValue", (evt) => {
            setSelected([evt.detail]);
        }, false);
    });

    return (<Typeahead          
        id= {props.id || new Date().getTime()}
        labelKey= {props.labelKey}
        onChange={
            (selected) => {
            setSelected(selected);
            if (props.onChange && undefined !== selected[0]) { props.onChange(selected[0]) }
            else if (!selected || !selected.length) {props.onClear()}
            }
        }
        options={props.data}
        placeholder={props.placeholder}
        selected={selected}
        autocomplete="off"
        >
            {({ onClear, selected }) => (
            <div className="rbt-aux">
                {!!selected.length && <ClearButton onClick={onClear} />}
            </div>
            )}
        </Typeahead>);
};

export default Autocomplete